import ENV from "@/engine/env/web.env";
import initDatadog from "@/engine/metrics/datadog";

export default function initMetrics() {
  if (ENV.datadog.active) {
    initDatadog();
  }
}
